import {
  LANG_CODE_JAPANESE,
  REGEX_DATE_JAPANESE,
  REGEX_DATE_VIETNAMESE,
  REGEX_MONTH_JAPANESE,
  REGEX_MONTH_VIETNAMESE
} from '../common/constants';

export const dateFormated = (fieldName) => (value, vm) => {
  let result = null;
  const regex =
    vm.$i18n.locale === LANG_CODE_JAPANESE
      ? REGEX_DATE_JAPANESE
      : REGEX_DATE_VIETNAMESE;

  if (fieldName === 'resignationMonthFormattedTextField') {
    if (value !== '') {
      result = vm[fieldName].match(regex);
    } else {
      return true;
    }
  } else {
    result = vm[fieldName].match(regex);
  }

  if (result) {
    return true;
  } else {
    return false;
  }
};

export const monthFormated = (fieldName) => (value, vm) => {
  let result = null;
  const regex =
    vm.$i18n.locale === LANG_CODE_JAPANESE
      ? REGEX_MONTH_JAPANESE
      : REGEX_MONTH_VIETNAMESE;
  result = vm[fieldName].match(regex);
  if (result) {
    return true;
  } else {
    return false;
  }
};
